<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <mt-navbar v-model="selected" class="center" style="margin-top: 0.2rem">
        <mt-tab-item id="1" clss="up">{{ $t('nftpage.text1') }}</mt-tab-item>
        <mt-tab-item id="2" clss="up">{{ $t('nftpage.text2') }}</mt-tab-item>
      </mt-navbar>
      <!-- tab-container -->
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
          <div class="list2" v-if="nftList && nftList.length > 0">
            <div
              class="item"
              v-for="(item, index) in nftList"
              :key="index"
              @click="handleRoute('/user/nftdetail', item)">
              <div
                class="img-box"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.image + ')'
                }"></div>
              <div
                class="avater"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.babe_user_avatar + ')'
                }"></div>
              <div class="av">{{ item.babe_user_name }}</div>
            </div>
          </div>
          <EmptyBox
            :text="$t('nonft')"
            type="nft"
            v-if="nftList && nftList.length == 0" />
        </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <div class="list2" v-if="hotNftList && hotNftList.length > 0">
            <div
              class="item"
              v-for="(item, index) in hotNftList"
              :key="index"
              @click="handleRoute('/user/nftdetail', item)">
              <div
                class="img-box"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.image + ')'
                }"></div>
              <div class="av">{{ item.name }}</div>
            </div>
          </div>
          <EmptyBox
            :text="$t('nonft')"
            type="nft"
            v-if="hotNftList && hotNftList.length == 0" />
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>
<script>
import { postBabenfts, postHotfts } from '@/api/user'
import EmptyBox from '@/components/EmptyBox.vue'

export default {
  name: 'UserNftList',
  components: {
    EmptyBox
  },
  data() {
    return {
      selected: null,
      nftList: null,
      hotNftList: null,
      topStatus: '',
      allLoaded: false
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'UserNftDetail') {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  methods: {
    init() {
      console.log(this.$route.query.tabIndex)
      if (this.$route.query && this.$route.query.tabIndex) {
        this.selected = this.$route.query.tabIndex.toString()
      } else {
        this.selected = '1'
      }
      postHotfts().then((res) => {
        this.hotNftList = res.data.lists
      })
      postBabenfts().then((res) => {
        this.nftList = res.data.lists
      })
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/nftlist.vue